<template>
  <div>
    <section ref="home">
      <mdb-container>
        <navigation @scrollTo="scrollTo" />
        <mdb-row class="mt-5">
          <mdb-col
            md="6"
            class="extra-margin first-col animated fadeIn"
            v-if="about"
          >
            <div class="text-uppercase">
              <h5 class="grey-text"><strong>Hi there! I am</strong></h5>
              <h1 class="font-weight-bold">
                <strong>Mikołaj Smoleński</strong>
              </h1>
            </div>
            <p class="grey-text mt-4" v-html="about.position"></p>
            <mdb-btn @click.native="scrollTo('about')" color="elegant"
              >Let's start!</mdb-btn
            >
          </mdb-col>
          <mdb-col
            md="6"
            class="text-center face-col second-col animated fadeIn"
          >
            <img src="@/assets/face.png" class="face img-fluid" alt="My face" />
          </mdb-col>
        </mdb-row>
      </mdb-container>
    </section>
    <section ref="about">
      <mdb-container>
        <mdb-row>
          <mdb-col md="6" class="mb-4" v-if="about">
            <div class="text-uppercase">
              <h5 class="grey-text"><strong>Few words</strong></h5>
              <h3 class="font-weight-bold">About me</h3>
            </div>
            <p class="mt-4 grey-text" v-html="about.description"></p>
            <div
              class="d-flex align-items-center justify-content-center justify-content-md-start flex-column flex-md-row"
            >
              <a
                :href="about.cvPath"
                target="_blank"
                class="btn btn-elegant-2 mb-3 mr-0 mr-md-3"
                >Show CV</a
              >
              <div class="mb-2">
                <a
                  href="https://github.com/smolenski-mikolaj"
                  target="_blank"
                  class="mr-3"
                  ><mdb-icon fab size="2x" icon="github" class="text-white"
                /></a>
                <a
                  href="https://www.linkedin.com/in/miko%C5%82aj-smole%C5%84ski/"
                  target="_blank"
                  ><mdb-icon fab size="2x" icon="linkedin" class="text-white"
                /></a>
              </div>
            </div>
          </mdb-col>
          <mdb-col md="4" offsetMd="2" class="mb-4">
            <h5 class="text-uppercase mt-2 mb-2 blue-text">
              <strong>Personal information</strong>
            </h5>
            <div class="grey-text">
              <strong class="text-white">Full Name</strong>: Mikołaj
              Smoleński<br />
              <strong class="text-white">Date of Birth</strong>: 3 March 1991<br />
              <strong class="text-white">Age</strong>:
              {{
                new Date()
                  | moment('diff', new Date('1991', '03', '03'), 'years')
              }}
              Years Old<br />
              <h5 class="text-uppercase mt-4 mb-2 blue-text">
                <strong>Contact</strong>
              </h5>
              <strong class="text-white">Mail</strong>:
              smolenski.mikolaj@gmail.com<br />
              <strong class="text-white">Phone</strong>: +48 602 18 16 17<br />
              <strong class="text-white">City</strong>: Warsaw, PL<br />
              <strong class="text-white">Timezone</strong>: CET<br />
            </div>
          </mdb-col>
        </mdb-row>
      </mdb-container>
    </section>
    <section ref="projects" class="text-center projects" v-if="projects">
      <mdb-container>
        <h5 class="blue-text text-uppercase">
          <strong>My projects</strong>
        </h5>
        <h2 class="text-uppercase font-weight-bold">Commercial experience</h2>
        <img src="@/assets/deco.png" alt="Deco" />

        <mdb-row class="mt-5 d-flex justify-content-center align-items-center">
          <mdb-col class="mb-4" md="3" v-if="commercialProjects[3]">
            <mdb-card>
              <mdb-view>
                <mdb-card-image
                  :src="require('@/assets/havi.jpg')"
                  alt="Card image cap"
                />
                <a :href="commercialProjects[3].href" target="_blank"
                  ><mdb-mask flex-center waves overlay="black-slight"></mdb-mask
                ></a>

                <mdb-mask flex-center waves class="projects-mask">
                  <mdb-card-body class="card-info white-text">
                    <mdb-card-title tag="h6">{{
                      commercialProjects[3].title
                    }}</mdb-card-title>
                    <mdb-card-text class="white-text">{{
                      commercialProjects[3].stack
                    }}</mdb-card-text>
                  </mdb-card-body>
                </mdb-mask>
              </mdb-view>
            </mdb-card>
          </mdb-col>

          <mdb-col class="mb-4" md="3" v-if="commercialProjects[0]">
            <mdb-card>
              <mdb-view>
                <mdb-card-image
                  :src="require('@/assets/mdb-vue-ui-kit.jpg')"
                  alt="Card image cap"
                />
                <a :href="commercialProjects[0].href" target="_blank"
                  ><mdb-mask flex-center waves overlay="black-slight"></mdb-mask
                ></a>

                <mdb-mask flex-center waves class="projects-mask">
                  <mdb-card-body class="card-info white-text">
                    <mdb-card-title tag="h6">{{
                      commercialProjects[0].title
                    }}</mdb-card-title>
                    <mdb-card-text class="white-text">{{
                      commercialProjects[0].stack
                    }}</mdb-card-text>
                  </mdb-card-body>
                </mdb-mask>
              </mdb-view>
            </mdb-card>
          </mdb-col>

          <mdb-col class="mb-4" md="3" v-if="commercialProjects[2]">
            <mdb-card>
              <mdb-view>
                <mdb-card-image
                  :src="require('@/assets/verady.jpg')"
                  alt="Card image cap"
                />
                <a :href="commercialProjects[2].href" target="_blank"
                  ><mdb-mask flex-center waves overlay="black-slight"></mdb-mask
                ></a>

                <mdb-mask flex-center waves class="projects-mask">
                  <mdb-card-body class="card-info white-text">
                    <mdb-card-title tag="h6">{{
                      commercialProjects[2].title
                    }}</mdb-card-title>
                    <mdb-card-text class="white-text">{{
                      commercialProjects[2].stack
                    }}</mdb-card-text>
                  </mdb-card-body>
                </mdb-mask>
              </mdb-view>
            </mdb-card>
          </mdb-col>

          <mdb-col class="mb-4" md="3" v-if="commercialProjects[1]">
            <mdb-card>
              <mdb-view>
                <mdb-card-image
                  :src="require('@/assets/tailwind-elements.jpg')"
                  alt="Card image cap"
                />
                <a :href="commercialProjects[1].href" target="_blank"
                  ><mdb-mask flex-center waves overlay="black-slight"></mdb-mask
                ></a>

                <mdb-mask flex-center waves class="projects-mask">
                  <mdb-card-body class="card-info white-text">
                    <mdb-card-title tag="h6">{{
                      commercialProjects[1].title
                    }}</mdb-card-title>
                    <mdb-card-text class="white-text">{{
                      commercialProjects[1].stack
                    }}</mdb-card-text>
                  </mdb-card-body>
                </mdb-mask>
              </mdb-view>
            </mdb-card>
          </mdb-col>
        </mdb-row>

        <h5 class="blue-text text-uppercase mt-5">
          <strong>Side projects</strong>
        </h5>
        <h2 class="text-uppercase font-weight-bold">My own work</h2>
        <img src="@/assets/deco.png" alt="Deco" />

        <mdb-row class="mt-5 d-flex justify-content-center align-items-center">
          <mdb-col class="mb-4" md="3" v-if="projects[1]">
            <mdb-card>
              <mdb-view>
                <mdb-card-image
                  :src="require('@/assets/lampar.jpg')"
                  alt="Card image cap"
                />
                <a :href="projects[1].href" target="_blank"
                  ><mdb-mask flex-center waves overlay="black-slight"></mdb-mask
                ></a>

                <mdb-mask flex-center waves class="projects-mask">
                  <mdb-card-body class="card-info white-text">
                    <mdb-card-title tag="h6">{{
                      projects[1].title
                    }}</mdb-card-title>
                    <mdb-card-text class="white-text">{{
                      projects[1].stack
                    }}</mdb-card-text>
                  </mdb-card-body>
                </mdb-mask>
              </mdb-view>
            </mdb-card>
          </mdb-col>

          <mdb-col class="mb-4" md="3" v-if="projects[0]">
            <mdb-card>
              <mdb-view>
                <mdb-card-image
                  :src="require('@/assets/ilumaps.jpg')"
                  alt="Card image cap"
                />
                <a :href="projects[0].href" target="_blank"
                  ><mdb-mask flex-center waves overlay="black-slight"></mdb-mask
                ></a>

                <mdb-mask flex-center waves class="projects-mask">
                  <mdb-card-body class="card-info white-text">
                    <mdb-card-title tag="h6">{{
                      projects[0].title
                    }}</mdb-card-title>
                    <mdb-card-text class="white-text">{{
                      projects[0].stack
                    }}</mdb-card-text>
                  </mdb-card-body>
                </mdb-mask>
              </mdb-view>
            </mdb-card>
          </mdb-col>

          <mdb-col class="mb-4" md="3" v-if="projects[2]">
            <mdb-card class="custom-card">
              <mdb-view>
                <mdb-card-image
                  :src="require('@/assets/koshyk.png')"
                  alt="Card image cap"
                />
                <a :href="projects[2].href" target="_blank"
                  ><mdb-mask flex-center waves overlay="black-slight"></mdb-mask
                ></a>

                <mdb-mask flex-center waves class="projects-mask">
                  <mdb-card-body class="card-info white-text">
                    <mdb-card-title tag="h6">{{
                      projects[2].title
                    }}</mdb-card-title>
                    <mdb-card-text class="white-text">{{
                      projects[2].stack
                    }}</mdb-card-text>
                  </mdb-card-body>
                </mdb-mask>
              </mdb-view>
            </mdb-card>
          </mdb-col>

          <mdb-col class="mb-4" md="3" v-if="projects[3]">
            <mdb-card>
              <mdb-view>
                <mdb-card-image
                  :src="require('@/assets/serednie.jpg')"
                  alt="Card image cap"
                />
                <a :href="projects[3].href" target="_blank"
                  ><mdb-mask flex-center waves overlay="black-slight"></mdb-mask
                ></a>

                <mdb-mask flex-center waves class="projects-mask">
                  <mdb-card-body class="card-info white-text">
                    <mdb-card-title tag="h6">{{
                      projects[3].title
                    }}</mdb-card-title>
                    <mdb-card-text class="white-text">{{
                      projects[3].stack
                    }}</mdb-card-text>
                  </mdb-card-body>
                </mdb-mask>
              </mdb-view>
            </mdb-card>
          </mdb-col>
          <!-- <mdb-col class="mb-4" md="3" v-if="projects[4]">
            <mdb-card>
              <mdb-view>
                <mdb-card-image
                  :src="require('@/assets/lukasz.jpg')"
                  alt="Card image cap"
                />
                <a :href="projects[4].href" target="_blank"
                  ><mdb-mask flex-center waves overlay="black-slight"></mdb-mask
                ></a>

                <mdb-mask flex-center waves class="projects-mask">
                  <mdb-card-body class="card-info white-text">
                    <mdb-card-title class="font-weight-bold" tag="h5">{{
                      projects[4].title
                    }}</mdb-card-title>
                    <mdb-card-text class="white-text">{{
                      projects[4].stack
                    }}</mdb-card-text>
                  </mdb-card-body>
                </mdb-mask>
              </mdb-view>
            </mdb-card>
          </mdb-col> -->
        </mdb-row>
      </mdb-container>
    </section>

    <section
      ref="experience"
      class="text-center"
      v-if="experience && education"
    >
      <mdb-container>
        <mdb-row>
          <mdb-col sm="5" offsetSm="1" class="text-sm-left mb-5">
            <h2 class="text-uppercase font-weight-bold">IT Experience</h2>
            <img src="@/assets/deco.png" alt="Deco" class="mt-2" />

            <div
              v-for="(exp, key) in experience"
              :key="key"
              :class="exp.name ? 'mt-5' : 'mt-2'"
            >
              <h5 class="mb-1 font-weight-bold" v-if="exp.name">
                <a
                  v-if="exp.href"
                  :href="exp.href"
                  target="_blank"
                  class="white-text"
                  >{{ exp.name }}</a
                >
                <span v-else>{{ exp.name }}</span>
              </h5>
              <p class="mb-1">{{ exp.position }}</p>
              <small class="grey-text mb-0"
                ><mdb-icon icon="calendar-alt" class="blue-text mr-2" />
                <span>{{ exp.from.toDate() | moment('MMM YYYY') }}</span>
                <span> - </span>
                <span v-if="exp.to">{{
                  exp.to.toDate() | moment('MMM YYYY')
                }}</span>
                <span v-else>currently</span> </small
              ><br />
              <small v-if="exp.to" class="grey-text"
                ><mdb-icon icon="clock" class="mr-1 blue-text" />
                {{
                  new Date(exp.fakeTo.toDate())
                    | moment('diff', new Date(exp.from.toDate()), 'months')
                }}
                months</small
              >
              <small v-else class="grey-text"
                ><mdb-icon icon="clock" class="mr-1 blue-text" />
                {{
                  new Date()
                    | moment('diff', new Date(exp.from.toDate()), 'months')
                }}
                months</small
              >
            </div>
          </mdb-col>

          <mdb-col sm="5" offsetSm="1" class="text-sm-left mb-5">
            <h2 class="text-uppercase font-weight-bold">Education</h2>
            <img src="@/assets/deco.png" alt="Deco" class="mt-2" />

            <div v-for="(edu, key) in education" :key="key" class="mt-5">
              <h5 class="mb-1 font-weight-bold" v-html="edu.title"></h5>
              <p v-if="edu.subtitle" class="mb-1">{{ edu.subtitle }}</p>
              <small class="grey-text"
                ><mdb-icon icon="calendar-alt" class="blue-text mr-2" />{{
                  edu.from.toDate() | moment('MMM YYYY')
                }}
                - {{ edu.to.toDate() | moment('MMM YYYY') }}</small
              ><br />
            </div>
          </mdb-col>
        </mdb-row>
      </mdb-container>
    </section>

    <section ref="recommendations" v-if="recommendations">
      <mdb-container>
        <div class="text-center mb-5">
          <h2 class="text-uppercase font-weight-bold">Recommendations</h2>
          <img src="@/assets/deco.png" alt="Deco" />
        </div>
        <mdb-row>
          <mdb-col
            v-for="(recommendation, key) in recommendations"
            :key="key"
            sm="6"
            class="mb-4"
          >
            <h5 class="mb-1">{{ recommendation.author }}</h5>
            <p class="blue-text small">{{ recommendation.role }}</p>
            <p
              class="mt-4 grey-text small"
              v-html="recommendation.description"
            ></p>
          </mdb-col>
        </mdb-row>
      </mdb-container>
    </section>

    <section ref="timeline" class="text-center">
      <h5 class="blue-text text-uppercase"><strong>Timeline</strong></h5>
      <h3 class="font-weight-bold text-uppercase">My story</h3>
      <img src="@/assets/deco.png" alt="Deco" />

      <mdb-container class="mt-5">
        <mdb-row>
          <mdb-col md="12">
            <div>
              <ul class="timeline-1 text-black">
                <li
                  class="event"
                  v-for="timelineYear in timelineYears"
                  :key="timelineYear"
                  :data-date="timelineYear"
                >
                  <div
                    v-for="item in timelineYearsItems[timelineYear]"
                    :key="item.name"
                    class="mb-3"
                  >
                    <a v-if="item.href" :href="item.href" target="_blank">
                      <h6 class="mb-1">
                        {{ item.name }}
                      </h6>
                    </a>
                    <h6 v-else class="mb-1 primary">
                      <strong>{{ item.name }}</strong>
                    </h6>
                    <p class="description">
                      <small>{{ item.description }}</small>
                    </p>
                  </div>
                </li>
              </ul>
            </div>
          </mdb-col>
        </mdb-row>
      </mdb-container>
    </section>

    <section class="publications" ref="publications" v-if="articles">
      <mdb-container>
        <div class="text-center">
          <h5 class="blue-text text-uppercase">
            <strong>Publications</strong>
          </h5>
          <h3 class="font-weight-bold text-uppercase">My Articles</h3>
          <img src="@/assets/deco.png" alt="Deco" />
        </div>
        <mdb-row class="mt-5">
          <mdb-col
            v-for="(article, key) in articles"
            :key="key"
            sm="4"
            class="mb-4"
          >
            <a :href="article.href" target="_blank">
              <mdb-card class="elegant-color">
                <mdb-card-body>
                  <mdb-card-title tag="h6">{{ article.title }}</mdb-card-title>
                  <mdb-card-text class="mt-3">{{
                    article.description
                  }}</mdb-card-text>
                  <small class="text-muted float-right mt-2"
                    ><mdb-icon icon="calendar-alt" class="mr-1" />
                    {{ article.date.toDate() | moment('DD.MM.YYYY') }}</small
                  >
                </mdb-card-body>
              </mdb-card>
            </a>
          </mdb-col>
        </mdb-row>
      </mdb-container>
    </section>

    <section ref="skills" class="text-center">
      <mdb-container>
        <h5 class="blue-text text-uppercase"><strong>Skills</strong></h5>
        <img src="@/assets/deco.png" alt="Deco" />
        <mdb-row class="d-flex justify-content-center mt-5">
          <div class="d-flex flex-column m-3">
            <mdb-icon brands icon="js" size="3x" />
            <span><strong>JavaScript</strong></span>
          </div>
          <div class="d-flex flex-column m-3">
            <mdb-icon brands icon="vuejs" size="3x" />
            <span><strong>Vue</strong></span>
          </div>
          <div class="d-flex flex-column m-3">
            <mdb-icon brands icon="react" size="3x" />
            <span><strong>React</strong></span>
          </div>
          <div class="d-flex flex-column m-3">
            <mdb-icon brands icon="node" size="3x" />
            <span><strong>Node</strong></span>
          </div>
          <div class="d-flex flex-column m-3">
            <mdb-icon brands icon="mdb" size="3x" />
            <span><strong>MDB</strong></span>
          </div>
          <div class="d-flex flex-column m-3">
            <mdb-icon brands icon="html5" size="3x" />
            <span><strong>HTML</strong></span>
          </div>
          <div class="d-flex flex-column m-3">
            <mdb-icon brands icon="css3" size="3x" />
            <span><strong>CSS</strong></span>
          </div>
          <div class="d-flex flex-column m-3">
            <mdb-icon brands icon="sass" size="3x" />
            <span><strong>Sass</strong></span>
          </div>
          <div class="d-flex flex-column m-3">
            <mdb-icon brands icon="git" size="3x" />
            <span><strong>Git</strong></span>
          </div>
          <div class="d-flex flex-column m-3">
            <mdb-icon brands icon="php" size="3x" />
            <span><strong>PHP</strong></span>
          </div>
          <div class="d-flex flex-column m-3">
            <mdb-icon brands icon="trello" size="3x" />
            <span><strong>Trello</strong></span>
          </div>
          <div class="d-flex flex-column m-3">
            <mdb-icon brands icon="slack" size="3x" />
            <span><strong>Slack</strong></span>
          </div>
          <div class="d-flex flex-column m-3">
            <mdb-icon brands icon="confluence" size="3x" />
            <span><strong>Confluence</strong></span>
          </div>
        </mdb-row>
      </mdb-container>
    </section>

    <section ref="contact">
      <mdb-container>
        <div class="d-flex align-items-center">
          <div
            class="d-flex justify-content-center align-items-center rounded-circle"
            style="height: 35px; width: 35px; border: 1px solid #2196f3;"
          >
            <mdb-icon icon="phone" />
          </div>
          <div class="ml-2">+48 602 18 16 17</div>
        </div>
        <div class="d-flex align-items-center mt-2">
          <div
            class="d-flex justify-content-center align-items-center rounded-circle"
            style="height: 35px; width: 35px; border: 1px solid #2196f3;"
          >
            <mdb-icon icon="envelope" />
          </div>
          <div class="ml-2">smolenski.mikolaj@gmail.com</div>
        </div>
      </mdb-container>
    </section>

    <footer class="grey-text">
      <mdb-container>
        <span
          >WEBICO Mikołaj Smoleński <mdb-icon icon="copyright" />
          {{ new Date().getFullYear() }}</span
        >
        <span class="float-right">
          <a
            href="https://github.com/smolenski-mikolaj"
            target="_blank"
            class="mr-1 grey-text"
            ><mdb-icon brands icon="github"
          /></a>
          <a
            href="https://www.linkedin.com/in/miko%C5%82aj-smole%C5%84ski/"
            target="_blank"
            class="grey-text"
            ><mdb-icon brands icon="linkedin"
          /></a>
        </span>
      </mdb-container>
    </footer>
  </div>
</template>

<script>
import {
  mdbContainer,
  mdbRow,
  mdbCol,
  mdbBtn,
  mdbCard,
  mdbCardImage,
  mdbCardBody,
  mdbCardTitle,
  mdbCardText,
  mdbView,
  mdbMask,
  mdbIcon,
} from 'mdbvue'
import Navigation from './Navigation'
import { db } from '../main'

export default {
  name: 'Main',
  components: {
    Navigation,
    mdbContainer,
    mdbRow,
    mdbCol,
    mdbBtn,
    mdbCard,
    mdbCardImage,
    mdbCardBody,
    mdbCardTitle,
    mdbCardText,
    mdbView,
    mdbMask,
    mdbIcon,
  },
  data() {
    return {
      about: [],
      commercialProjects: [],
      projects: [],
      experience: [],
      education: [],
      articles: [],
      timeline: [],
      recommendations: [],
    }
  },
  firestore() {
    return {
      about: db.collection('basicData').doc('about'),
      commercialProjects: db.collection('commercialProjects'),
      projects: db.collection('projects'),
      experience: db.collection('experience').orderBy('from', 'desc'),
      education: db.collection('education').orderBy('from', 'desc'),
      articles: db.collection('articles').orderBy('date', 'asc'),
      timeline: db.collection('timeline'),
      recommendations: db.collection('recommendations').orderBy('date', 'desc'),
    }
  },
  methods: {
    scrollTo(ref) {
      let element = this.$refs[ref]
      let top = element.offsetTop
      window.scrollTo({
        top: top,
        behavior: 'smooth',
      })
    },
  },
  computed: {
    timelineYears() {
      return [...new Set(this.timeline.map((item) => item.year))]
    },
    timelineYearsItems() {
      const items = {}
      this.timelineYears.forEach((year) => {
        items[year] = this.timeline.filter((item) => item.year === year)
      })

      return items
    },
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
section {
  padding: 100px 0;
}
section:nth-child(odd) {
  background-color: #202020;
}
section:nth-child(even) {
  background-color: #2b2b2b;
}
.extra-margin {
  margin-top: 100px;
  margin-bottom: 20px;
}
.btn {
  margin-left: 0;
}
.btn,
.btn:hover {
  color: white;
}
.face {
  margin-bottom: -100px;
  max-height: 500px;
}
.projects .view > div {
  max-height: 360px;
}
.projects .card-body {
  background-color: transparent;
}
.projects .card-info {
  position: absolute;
  left: 0;
  bottom: 0;
  width: 100%;
}
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.2s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
footer {
  line-height: 50px;
  background-color: #2b2b2b;
  font-size: 12px;
  text-align: left;
}
footer a {
  margin-left: 5px;
}
footer .fab {
  font-size: 22px;
  margin-top: 10px;
}
@media (max-width: 992px) {
  h1 {
    font-size: 2rem;
  }
  .extra-margin {
    margin-top: 0;
    margin-bottom: 0;
  }
}
@media (max-width: 768px) {
  .face {
    margin-bottom: 50px;
  }
  .first-col {
    order: 2;
  }
  .second-col {
    order: 1;
  }
  .col-left {
    text-align: center;
  }
  .col-right {
    text-align: center;
  }
  .projects .col-sm-4 {
    padding: 0 30px;
  }
}
.timeline-1 {
  border-left: 3px solid #2196f3;
  border-bottom-right-radius: 4px;
  border-top-right-radius: 4px;
  background: rgba(99, 134, 177, 0.09);
  margin: 0 auto;
  position: relative;
  padding: 50px;
  list-style: none;
  text-align: left;
  max-width: 60%;
}

@media (max-width: 767px) {
  .timeline-1 {
    max-width: 98%;
    padding: 25px;
  }
}

.timeline-1 .event {
  border-bottom: 1px dashed #74777b;
  padding-bottom: 10px;
  margin-bottom: 25px;
  position: relative;
}

@media (max-width: 767px) {
  .timeline-1 .event {
    padding-top: 30px;
  }
}

.timeline-1 .event:last-of-type {
  padding-bottom: 0;
  margin-bottom: 0;
  border: none;
}

.timeline-1 .event:before,
.timeline-1 .event:after {
  position: absolute;
  display: block;
  top: 0;
}

.timeline-1 .event:before {
  left: -207px;
  content: attr(data-date);
  text-align: right;
  font-weight: 100;
  font-size: 0.9em;
  min-width: 120px;
}

@media (max-width: 767px) {
  .timeline-1 .event:before {
    left: 0px;
    text-align: left;
  }
}

.timeline-1 .event:after {
  -webkit-box-shadow: 0 0 0 3px #2196f3;
  box-shadow: 0 0 0 3px #2196f3;
  left: -55.8px;
  background: #fff;
  border-radius: 50%;
  height: 9px;
  width: 9px;
  content: '';
  top: 5px;
}

@media (max-width: 767px) {
  .timeline-1 .event:after {
    left: -31.8px;
  }
}
.description {
  line-height: 1.2;
  color: #909090;
}

.small {
  font-size: 14px;
}
</style>

<style>
a,
.primary {
  color: #2196f3;
}
.btn-elegant-2 {
  background-color: #3e3e3e;
}
.card.custom-card {
  border-top-left-radius: 40px;
  border-top-right-radius: 40px;
}
a:hover,
.primary:hover {
  color: #5eb3f7;
}
.navbar .ripple-parent {
  overflow: unset;
}
.projects .view {
  overflow: unset;
}
a,
button,
.projects a:focus .mask,
.timeline-1 a:focus h6,
.publications a:focus .card {
  transition: outline 0.1s !important;
}
a:focus,
button:focus,
.projects a:focus .mask,
.timeline-1 a:focus h6,
.publications a:focus .card {
  outline: 3px solid white !important;
  outline-offset: 3px;
}

.projects .view img {
  -webkit-filter: grayscale(10%); /* Safari 6.0 - 9.0 */
  filter: grayscale(10%);
  width: 100%;
}
.projects-mask {
  top: auto !important;
  bottom: 0 !important;
  height: 200px !important;
  background-attachment: unset !important;
  background: linear-gradient(
    180deg,
    rgba(8, 85, 148, 0) 0%,
    rgba(0, 30, 90, 0.94) 60%,
    rgb(0, 30, 90) 100%
  );
  cursor: default;
  pointer-events: none;
}
.card .projects-mask .card-text {
  font-size: 0.7rem;
}
</style>
